import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import Shadow from '../../../../components/Shadow/Shadow';
import Style from '../../../../styles/common';

const Container = styled('div')`
  
`;

const Offset = styled('div')`
  position: relative;
  top: 50%;
`;

const Image = styled('img')`
  position: relative;
  vertical-align: top;
  width: ${Style.size.width.poster};
  z-index: 1;
`;

function Poster(props) {
  return (
    <Container>
      <Offset>
        <Image src={props.imageUrl}/>
        <Shadow/>
      </Offset>
    </Container>
  );
}

Poster.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};
Poster.defaultProps = {};

export default Poster;



// WEBPACK FOOTER //
// ./src/views/Detail/DetailHeader/Poster/Poster.js